import { BaseComponent } from "@symbiotejs/symbiote";
import { I18n } from "../utilities/i18n/i18n";
import { GridOrchestrator } from "../components/grid-orchestrator/grid-orchestrator";
import {PwaGuard} from "../components/pwa-guard/pwa-guard";


const nav_search = require('./assets/search_events.png')
const nav_basket = require('./assets/basket.png')
const nav_tickets = require('./assets/reserved.png')

const vog = require('./assets/vog.jpg')
const topView = require('./assets/top_view.png')

export class EventContainer extends BaseComponent {
    initCallback() {
        // GridOrchestrator.deactivateGameFilters();
        if (PwaGuard.accessIsThroughIphone() !== 0) {
            document.getElementById('navigationBar').style.minHeight = '6rem';
        }
    }
}

EventContainer.template = /*html*/ `
        <style>/*! chunkhash: b52cbe2faeb6d7fbc272 *//*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
    *, :after, :before {
        box-sizing: border-box
    }

    html {
        -webkit-text-size-adjust: 100%
    }

    body {
        margin: 0
    }

    main {
        display: block
    }

    h1 {
        margin: .67em 0
    }

    hr {
        box-sizing: content-box;
        height: 0;
        overflow: visible
    }
    
     
    .cc-wrapperContainer .icon-container {
      position: relative;
      display: inline-block; /* shrink‐wrap to icon */
    }
    
    /* 2. Style the badge */
    .cc-badge {
      position: absolute;
      top: -4px;
      left: 15px;
      background-color: #FF3B30;      /* iOS-style red */
      color: #FFFFFF;                /* white text */
      border-radius: 10px;           /* pill shape */
      padding: 0 6px;                /* horizontal padding */
      font-size: 10px;               /* small text */
      font-weight: bold;
      line-height: 18px;             /* vertically center the number */
      min-width: 18px;               /* ensure a circle for 1‐digit */
      text-align: center;
      box-shadow: 0 0 0 1px rgba(0,0,0,0.1); /* subtle border */
    }

    img {
        border-style: none
    }

    ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit
    }

    html {
        text-size-adjust: 100%;
        -ms-overflow-style: scrollbar;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        font-family: sans-serif;
        font-size: 16px;
        line-height: 1.15
    }

    body {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: var(--color-text-primary);
        font-family: var(--font-family);
        font-size: var(--font-size-s2);
        font-weight: var(--font-weight-regular);
        line-height: 1.45;
        text-rendering: optimizelegibility
    }

    :root {
        --breakpoint-sm: 576px;
        --breakpoint-md: 768px;
        --breakpoint-lg: 992px;
        --breakpoint-xl: 1200px;
        --breakpoint-xxl: 1400px;
        --container-width-sm: 540px;
        --container-width-md: 720px;
        --container-width-lg: 960px;
        --container-width-xl: 1140px;
        --container-width-xxl: 1320px;
        --font-size-s1: 0.75rem;
        --font-size-s2: 0.875rem;
        --font-size-s3: 1rem;
        --font-size-s4: 1.125rem;
        --font-size-s5: 1.5rem;
        --font-size-s6: 2rem;
        --font-size-s7: 2.5rem;
        --font-size-s8: 3rem;
        --font-family: Averta, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        --font-weight-regular: 400;
        --font-weight-bold: 700;
        --shape-rectangle: 0px;
        --shape-rounded-s0: 2px;
        --shape-rounded-s1: 4px;
        --shape-rounded-s2: 8px;
        --shape-rounded-s3: 12px;
        --shape-rounded-s4: 16px;
        --shape-circle: 50%;
        --shape-pill: 14px;
        --spacing-s1: 0.125rem;
        --spacing-s2: 0.25rem;
        --spacing-s3: 0.5rem;
        --spacing-s4: 1rem;
        --spacing-s5: 1.5rem;
        --spacing-s6: 2rem;
        --spacing-s7: 2.5rem;
        --spacing-s8: 3rem;
        --spacing-s9: 3.5rem;
        --spacing-s10: 4rem;
        --z-index-dropdown: 1000;
        --z-index-fixed: 1030;
        --z-index-drawer: 2000;
        --z-index-modal: 2051;
        --drawer-default-size: 375px
    }

    :root .sonata-light-theme, :root [data-theme=sonata-light-theme] {
        --color-blue-h: 215;
        --color-blue-s: 69%;
        --color-blue-l: 49%;
        --color-blue: hsl(var(--color-blue-h) var(--color-blue-s) var(--color-blue-l));
        --color-blue-light-h: 217;
        --color-blue-light-s: 62%;
        --color-blue-light-l: 96%;
        --color-blue-light: hsl(var(--color-blue-light-h) var(--color-blue-light-s) var(--color-blue-light-l));
        --color-green-h: 164;
        --color-green-s: 100%;
        --color-green-l: 35%;
        --color-green: hsl(var(--color-green-h) var(--color-green-s) var(--color-green-l));
        --color-green-light-h: 159;
        --color-green-light-s: 70%;
        --color-green-light-l: 96%;
        --color-green-light: hsl(var(--color-green-light-h) var(--color-green-light-s) var(--color-green-light-l));
        --color-yellow-h: 46;
        --color-yellow-s: 100%;
        --color-yellow-l: 50%;
        --color-yellow: hsl(var(--color-yellow-h) var(--color-yellow-s) var(--color-yellow-l));
        --color-yellow-light-h: 55;
        --color-yellow-light-s: 100%;
        --color-yellow-light-l: 93%;
        --color-yellow-light: hsl(var(--color-yellow-light-h) var(--color-yellow-light-s) var(--color-yellow-light-));
        --color-red-h: 0;
        --color-red-s: 84%;
        --color-red-l: 47%;
        --color-red: hsl(var(--color-red-h) var(--color-red-s) var(--color-red-l));
        --color-red-light-h: 0;
        --color-red-light-s: 75%;
        --color-red-light-l: 97%;
        --color-red-light: hsl(var(--color-red-light-h) var(--color-red-light-s) var(--color-red-light-l));
        --color-black-h: 0;
        --color-black-s: 0%;
        --color-black-l: 8%;
        --color-black: hsl(var(--color-black-h) var(--color-black-s) var(--color-black-l));
        --color-grey-h: 0;
        --color-grey-s: 0%;
        --color-grey-l: 44%;
        --color-grey: hsl(var(--color-grey-h) var(--color-grey-s) var(--color-grey-l));
        --color-grey-light-h: 0;
        --color-grey-light-s: 0%;
        --color-grey-light-l: 67%;
        --color-grey-light: hsl(var(--color-grey-light-h) var(--color-grey-light-s) var(--color-grey-light-l));
        --color-grey-lighter-h: 0;
        --color-grey-lighter-s: 0%;
        --color-grey-lighter-l: 96%;
        --color-grey-lighter: hsl(var(--color-grey-lighter-h) var(--color-grey-lighter-s) var(--color-grey-lighter-l));
        --color-white-h: 0;
        --color-white-s: 0%;
        --color-white-l: 100%;
        --color-white: hsl(var(--color-white-h) var(--color-white-s) var(--color-white-l));
        --color-background-h: var(--color-grey-lighter-h);
        --color-background-s: var(--color-grey-lighter-s);
        --color-background-l: var(--color-grey-lighter-l);
        --color-background: hsl(var(--color-background-h) var(--color-background-s) var(--color-background-l));
        --color-background-secondary-h: var(--color-grey-light-h);
        --color-background-secondary-s: var(--color-grey-light-s);
        --color-background-secondary-l: var(--color-grey-light-l);
        --color-background-secondary: hsl(var(--color-background-secondary-h) var(--color-background-secondary-s) var(--color-background-secondary-l));
        --color-surface-h: var(--color-white-h);
        --color-surface-s: var(--color-white-s);
        --color-surface-l: var(--color-white-l);
        --color-surface: hsl(var(--color-surface-h) var(--color-surface-s) var(--color-surface-l));
        --color-surface-secondary-h: var(--color-black-h);
        --color-surface-secondary-s: var(--color-black-s);
        --color-surface-secondary-l: var(--color-black-l);
        --color-surface-secondary: hsl(var(--color-surface-secondary-h) var(--color-surface-secondary-s) var(--color-surface-secondary-l));
        --color-border-primary-h: var(--color-grey-light-h);
        --color-border-primary-s: var(--color-grey-light-s);
        --color-border-primary-l: var(--color-grey-light-l);
        --color-border-primary: hsl(var(--color-border-primary-h) var(--color-border-primary-s) var(--color-border-primary-l));
        --color-border-secondary-h: var(--color-grey-h);
        --color-border-secondary-s: var(--color-grey-s);
        --color-border-secondary-l: var(--color-grey-l);
        --color-border-secondary: hsl(var(--color-border-secondary-h) var(--color-border-secondary-s) var(--color-border-secondary-l));
        --color-divider-primary-h: var(--color-grey-lighter-h);
        --color-divider-primary-s: var(--color-grey-lighter-s);
        --color-divider-primary-l: var(--color-grey-lighter-l);
        --color-divider-primary: hsl(var(--color-divider-primary-h) var(--color-divider-primary-s) var(--color-divider-primary-l));
        --color-outline-h: var(--color-green-light-h);
        --color-outline-s: var(--color-green-light-s);
        --color-outline-l: var(--color-green-light-l);
        --color-outline: hsl(var(--color-outline-h) var(--color-outline-s) var(--color-outline-l));
        --color-text-primary-h: var(--color-black-h);
        --color-text-primary-s: var(--color-black-s);
        --color-text-primary-l: var(--color-black-l);
        --color-text-primary: hsl(var(--color-text-primary-h) var(--color-text-primary-s) var(--color-text-primary-l));
        --color-text-secondary-h: var(--color-grey-h);
        --color-text-secondary-s: var(--color-grey-s);
        --color-text-secondary-l: var(--color-grey-l);
        --color-text-secondary: hsl(var(--color-text-secondary-h) var(--color-text-secondary-s) var(--color-text-secondary-l));
        --color-text-disabled-h: var(--color-grey-light-h);
        --color-text-disabled-s: var(--color-grey-light-s);
        --color-text-disabled-l: var(--color-grey-light-l);
        --color-text-disabled: hsl(var(--color-text-disabled-h) var(--color-text-disabled-s) var(--color-text-disabled-l));
        --color-success-primary-h: var(--color-green-h);
        --color-success-primary-s: var(--color-green-s);
        --color-success-primary-l: var(--color-green-l);
        --color-success-primary: hsl(var(--color-success-primary-h) var(--color-success-primary-s) var(--color-success-primary-l));
        --color-success-secondary-h: var(--color-green-light-h);
        --color-success-secondary-s: var(--color-green-light-s);
        --color-success-secondary-l: var(--color-green-light-l);
        --color-success-secondary: hsl(var(--color-success-secondary-h) var(--color-success-secondary-s) var(--color-success-secondary-l));
        --color-warning-primary-h: var(--color-yellow-h);
        --color-warning-primary-s: var(--color-yellow-s);
        --color-warning-primary-l: var(--color-yellow-l);
        --color-warning-primary: hsl(var(--color-warning-primary-h) var(--color-warning-primary-s) var(--color-warning-primary-l));
        --color-warning-secondary-h: var(--color-yellow-light-h);
        --color-warning-secondary-s: var(--color-yellow-light-s);
        --color-warning-secondary-l: var(--color-yellow-light-l);
        --color-warning-secondary: hsl(var(--color-warning-secondary-h) var(--color-warning-secondary-s) var(--color-warning-secondary-l));
        --color-error-primary-h: var(--color-red-h);
        --color-error-primary-s: var(--color-red-s);
        --color-error-primary-l: var(--color-red-l);
        --color-error-primary: hsl(var(--color-error-primary-h) var(--color-error-primary-s) var(--color-error-primary-l));
        --color-error-secondary-h: var(--color-red-light-h);
        --color-error-secondary-s: var(--color-red-light-s);
        --color-error-secondary-l: var(--color-red-light-l);
        --color-error-secondary: hsl(var(--color-error-secondary-h) var(--color-error-secondary-s) var(--color-error-secondary-l));
        --color-rating-empty-h: var(--color-grey-h);
        --color-rating-empty-s: var(--color-grey-s);
        --color-rating-empty-l: var(--color-grey-l);
        --color-rating-empty: hsl(var(--color-rating-empty-h) var(--color-rating-empty-s) var(--color-rating-empty-l));
        --color-rating-filled-h: var(--color-green-h);
        --color-rating-filled-s: var(--color-green-s);
        --color-rating-filled-l: var(--color-green-l);
        --color-rating-filled: hsl(var(--color-rating-filled-h) var(--color-rating-filled-s) var(--color-rating-filled-l));
        --color-favourite-filled-h: var(--color-red-h);
        --color-favourite-filled-s: var(--color-red-s);
        --color-favourite-filled-l: var(--color-red-l);
        --color-favourite-filled: hsl(var(--color-favourite-filled-h) var(--color-favourite-filled-s) var(--color-favourite-filled-l));
        --color-favourite-empty-h: var(--color-grey-h);
        --color-favourite-empty-s: var(--color-grey-s);
        --color-favourite-empty-l: var(--color-grey-l);
        --color-favourite-empty: hsl(var(--color-favourite-empty-h) var(--color-favourite-empty-s) var(--color-favourite-empty-l));
        --color-kb-focus-primary-h: var(--color-black-h);
        --color-kb-focus-primary-s: var(--color-black-s);
        --color-kb-focus-primary-l: var(--color-black-l);
        --color-kb-focus-primary: hsl(var(--color-kb-focus-primary-h) var(--color-kb-focus-primary-s) var(--color-kb-focus-primary-l));
        --color-kb-focus-secondary-h: var(--color-grey-h);
        --color-kb-focus-secondary-s: var(--color-grey-s);
        --color-kb-focus-secondary-l: var(--color-grey-l);
        --color-kb-focus-secondary: hsl(var(--color-kb-focus-secondary-h) var(--color-kb-focus-secondary-s) var(--color-kb-focus-secondary-l));
        --color-button-primary-h: var(--color-green-h);
        --color-button-primary-s: var(--color-green-s);
        --color-button-primary-l: var(--color-green-l);
        --color-button-primary: hsl(var(--color-button-primary-h) var(--color-button-primary-s) var(--color-button-primary-l));
        --color-button-primary-text-h: var(--color-black-h);
        --color-button-primary-text-s: var(--color-black-s);
        --color-button-primary-text-l: var(--color-black-l);
        --color-button-primary-text: hsl(var(--color-button-primary-text-h) var(--color-button-primary-text-s) var(--color-button-primary-text-l));
        --color-button-outline-h: var(--color-black-h);
        --color-button-outline-s: var(--color-black-s);
        --color-button-outline-l: var(--color-black-l);
        --color-button-outline: hsl(var(--color-button-outline-h) var(--color-button-outline-s) var(--color-button-outline-l));
        --color-button-outline-text-h: var(--color-black-h);
        --color-button-outline-text-s: var(--color-black-s);
        --color-button-outline-text-l: var(--color-black-l);
        --color-button-outline-text: hsl(var(--color-button-outline-text-h) var(--color-button-outline-text-s) var(--color-button-outline-text-l));
        --color-button-outline-secondary-h: var(--color-white-h);
        --color-button-outline-secondary-s: var(--color-white-s);
        --color-button-outline-secondary-l: var(--color-white-l);
        --color-button-outline-secondary: hsl(var(--color-button-outline-secondary-h) var(--color-button-outline-secondary-s) var(--color-button-outline-secondary-l));
        --color-button-outline-secondary-text-h: var(--color-white-h);
        --color-button-outline-secondary-text-s: var(--color-white-s);
        --color-button-outline-secondary-text-l: var(--color-white-l);
        --color-button-outline-secondary-text: hsl(var(--color-button-outline-secondary-text-h) var(--color-button-outline-secondary-text-s) var(--color-button-outline-secondary-text-l));
        --color-button-secondary-h: var(--color-grey-lighter-h);
        --color-button-secondary-s: var(--color-grey-lighter-s);
        --color-button-secondary-l: var(--color-grey-lighter-l);
        --color-button-secondary: hsl(var(--color-button-secondary-h) var(--color-button-secondary-s) var(--color-button-secondary-l));
        --color-button-secondary-text-h: var(--color-black-h);
        --color-button-secondary-text-s: var(--color-black-s);
        --color-button-secondary-text-l: var(--color-black-l);
        --color-button-secondary-text: hsl(var(--color-button-secondary-text-h) var(--color-button-secondary-text-s) var(--color-button-secondary-text-l));
        --color-button-tertiary-h: var(--color-black-h);
        --color-button-tertiary-s: var(--color-black-s);
        --color-button-tertiary-l: var(--color-black-l);
        --color-button-tertiary: hsl(var(--color-button-tertiary-h) var(--color-button-tertiary-s) var(--color-button-tertiary-l));
        --color-button-tertiary-text-h: var(--color-white-h);
        --color-button-tertiary-text-s: var(--color-white-s);
        --color-button-tertiary-text-l: var(--color-white-l);
        --color-button-tertiary-text: hsl(var(--color-button-tertiary-text-h) var(--color-button-tertiary-text-s) var(--color-button-tertiary-text-l));
        --color-button-white-h: var(--color-white-h);
        --color-button-white-s: var(--color-white-s);
        --color-button-white-l: var(--color-white-l);
        --color-button-white: hsl(var(--color-button-white-h) var(--color-button-white-s) var(--color-button-white-l));
        --color-button-white-text-h: var(--color-black-h);
        --color-button-white-text-s: var(--color-black-s);
        --color-button-white-text-l: var(--color-black-l);
        --color-button-white-text: hsl(var(--color-button-white-text-h) var(--color-button-white-text-s) var(--color-button-white-text-l))
    }

    @keyframes sn-spin {
        0% {
            transform: rotate(0deg)
        }
        to {
            transform: rotate(1turn)
        }
    }

    @keyframes sn-pulse {
        0% {
            opacity: 1
        }
        50% {
            opacity: .6
        }
        to {
            opacity: 1
        }
    }

    @keyframes sn-fade {
        0% {
            opacity: 0
        }
        to {
            opacity: 1
        }
    }

    @keyframes sn-slide-top-full {
        0% {
            transform: translateY(-100%)
        }
        to {
            transform: translateY(0)
        }
    }

    @keyframes sn-slide-bottom-full {
        0% {
            transform: translateY(100%)
        }
        to {
            transform: translateY(0)
        }
    }

    @keyframes sn-slide-left-full {
        0% {
            transform: translateX(-100%)
        }
        to {
            transform: translateX(0)
        }
    }

    @keyframes sn-slide-right-full {
        0% {
            transform: translateX(100%)
        }
        to {
            transform: translateX(0)
        }
    }

    @keyframes sn-slide-across-x {
        0% {
            transform: translateX(-100%)
        }
        to {
            transform: translateX(100%)
        }
    }

    @keyframes sn-slide-across-y {
        0% {
            transform: translateY(-100%)
        }
        to {
            transform: translateY(100%)
        }
    }


    @keyframes cc-pulseAnimation_a2faaa {
        0% {
            transform: scale(1) rotate(0deg)
        }
        25% {
            transform: scale(.85) rotate(12deg)
        }
        50% {
            transform: scale(.65) rotate(18deg)
        }
        75% {
            transform: scale(1.06) rotate(8deg)
        }
        to {
            transform: scale(1) rotate(0deg)
        }
    }

    :root .sonata-dark-theme, :root .sonata-light-theme, :root [data-theme=sonata-dark-theme], :root [data-theme=sonata-light-theme] {
        --color-backdrop-h: var(--color-black-h);
        --color-backdrop-s: var(--color-black-s);
        --color-backdrop-l: var(--color-black-l);
        --color-backdrop: hsl(var(--color-backdrop-h) var(--color-backdrop-s) var(--color-backdrop-l))
    }

    @keyframes sn-slide-top-drawer_031d93 {
        0% {
            transform: translateY(calc(var(--drawer-default-size) * -1))
        }
        to {
            transform: translateY(0)
        }
    }

    @keyframes sn-slide-bottom-drawer_a5f183 {
        0% {
            transform: translateY(100%)
        }
        to {
            transform: translateY(calc(100% - var(--drawer-default-size)))
        }
    }

    @keyframes sn-slide-left-drawer_a6b2d7 {
        0% {
            transform: translateX(calc(var(--drawer-default-size) * -1))
        }
        to {
            transform: translateX(0)
        }
    }

    @keyframes sn-slide-right-drawer_874c6f {
        0% {
            transform: translateX(100%)
        }
        to {
            transform: translateX(calc(100% - var(--drawer-default-size)))
        }
    }

    @keyframes cc-pulseAnimation_b42778 {
        0% {
            transform: scale(1) rotate(0deg)
        }
        25% {
            transform: scale(.85) rotate(12deg)
        }
        50% {
            transform: scale(.65) rotate(18deg)
        }
        75% {
            transform: scale(1.06) rotate(8deg)
        }
        to {
            transform: scale(1) rotate(0deg)
        }
    }



    .sn-appContainer_9e3a25 {
        z-index: 100
    }


    .cc-deliveryType_9c532e {
    padding-bottom: 5px;
    border-bottom: 1px solid #b9b9b9;
        align-items: center;
        color: var(--color-text-primary);
        cursor: pointer;
        display: flex;
        float: left;
        font-size: var(--font-size-s1);
        font-weight: var(--font-weight-regular)
    }

    .cc-angleDown_ecfd80 {
        height: 12px;
        margin-left: var(--spacing-s2);
        width: 12px
    }

    .cc-wrapper_bf3adc {
        display: flex;
        flex-direction: column;
        margin: 0
    }

    .cc-shopItemWrapper_106e84 {
        background: var(--color-surface);
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        display: flex;
        flex-direction: column;
        min-height: 64px;
        padding: var(--spacing-s5) var(--spacing-s4) 0 var(--spacing-s4);
        width: 100%;
        z-index: 1
    }

    .cc-shopItemRow_63d3c5 {
        align-items: center;
        display: flex;
        justify-content: space-between;
        width: 100%
    }

    .cc-shopItemHeaderRow_d1c91a {
        margin-bottom: var(--spacing-s4)
    }

    .cc-title_ec3f8e {
        font-size: var(--font-size-s5);
        margin-bottom: 0;
        margin-top: 0
    }


    @keyframes sn-bounce-swipeable-stack_f3bf03 {
        0%, 20%, 50%, 80%, to {
            transform: translateX(0)
        }
        40% {
            transform: translateX(-72px)
        }
        60% {
            transform: translateX(-36px)
        }
    }


    @keyframes sn-slideUpSmall_b6d058 {
        0% {
            transform: translateY(10%)
        }
        to {
            transform: translateY(0)
        }
    }

    :root .sonata-light-theme, :root [data-theme=sonata-light-theme] {
        --color-background-rating-h: var(--color-green-light-h);
        --color-background-rating-s: var(--color-green-light-s);
        --color-background-rating-l: var(--color-green-light-l);
        --color-background-rating: hsl(var(--color-background-rating-h) var(--color-background-rating-s) var(--color-background-rating-l))
    }


    .cc-logoWrapper_0e1a90 {
        position: relative
    }

    .cc-image_a03f68 {
        background: var(--color-text-secondary);
        border: none;
        border-radius: var(--shape-circle);
        display: inline-block
    }


    :root .sonata-light-theme, :root [data-theme=sonata-light-theme] {
        --color-background-skeleton-h: var(--color-grey-light-h);
        --color-background-skeleton-s: var(--color-grey-light-s);
        --color-background-skeleton-l: var(--color-grey-light-l);
        --color-background-skeleton: hsl(var(--color-background-skeleton-h) var(--color-background-skeleton-s) var(--color-background-skeleton-l))
    }

   </style>




<div class="sc-fZOUJb conWMH" id="navigationBar">

    <style>

        /*! CSS Used from: Embedded */
        *, :after, :before {
            box-sizing: border-box;
        }

        .sn-overflow-ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .cc-wrapper_9babfd {
            align-items: center;
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-around;
            margin: 0 var(--spacing-s2);
            min-width: 0;
            padding: 0 var(--spacing-s3);
            position: relative;
        }

        .cc-wrapper_9babfd:hover {
            cursor: pointer;
        }

        .cc-label_b4f792 {
            font-size: var(--font-size-s1);
            max-width: 100%;
        }

        .cc-navigationIcon_763ff2 {
            height: 1.2rem;
            margin-top: var(--spacing-s3);
            width: 1.2rem;
        }

        .cc-label_b4f792, .cc-navigationIcon_763ff2 {
            color: var(--color-text-secondary);
        }

        .cc-wrapperActive_669bbb .cc-label_b4f792, .cc-wrapperActive_669bbb .cc-navigationIcon_763ff2 {
            color: var(--color-surface-secondary);
        }

        .cc-wrapper_9babfd:after {
            background-color: transparent;
            border: var(--spacing-s1) solid transparent;
            border-radius: var(--shape-rounded-s0);
            content: "";
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
        }

        .cc-wrapperActive_669bbb:after {
            background-color: var(--color-surface-secondary);
            border-color: var(--color-surface-secondary);
        }

        .cc-wrapper_f06cbe {
            background-color: var(--color-surface);
            box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, .08);
            height: var(--spacing-s10);
        }

        .cc-wrapper_f06cbe {
            align-items: center;
            display: flex;
            justify-content: center;
        }

        /*! CSS Used from: Embedded */
        .conWMH {
            width: 100%;
            position: fixed;
            bottom: 0px;
            left: 0px;
            animation: 0.3s ease-in-out 0s 1 normal none running crmfwB;
            padding-bottom: env(safe-area-inset-bottom);
            background-color: rgb(255, 255, 255);
            z-index: 1030;
        }

    </style>

    <div class="cc-wrapper_f06cbe" >
    <a href="/en" style="color: inherit;text-decoration: none;" class="cc-wrapper_9babfd cc-wrapperActive_669bbb cc-wrapperContainer">
    <div class="icon-container">
    <img class="cc-navigationIcon_763ff2" src="${nav_search}">
    </div>
    <div class="sn-overflow-ellipsis cc-label_b4f792">Αναζήτηση</div>
    </a>
    <div class="cc-wrapper_9babfd cc-wrapperContainer" >
    <div class="icon-container">
    <img class="cc-navigationIcon_763ff2" src="${nav_basket}">
    <span class="cc-badge">3</span>
    </div>
    <div class="sn-overflow-ellipsis cc-label_b4f792">Καλάθι</div>
    </div>
    <div class="cc-wrapper_9babfd cc-wrapperContainer">
    <div class="icon-container">
    <img class="cc-navigationIcon_763ff2" src="${nav_tickets}">
    </div>
    <div class="sn-overflow-ellipsis cc-label_b4f792">Κρατήσεις</div>
    </div>
    </div>

</div>


<div id="main-container">
    <div id="smartbanner-container"></div>
    <main>
        <div id="shop-profile-page">
            <div class="sn-appContainer_9e3a25">
                <div class="sc-fcmNiO jlNmTW">
                    <div class="sc-bjPlYb" style="position: absolute;align-items: center;width: 100%;height: 100%;">
                        <div class="sc-eZuSHg iqGAUJ">
                            <div class="cc-wrapper_bf3adc sc-czggsR jYwPKD">
                                <div class="cc-shopItemWrapper_106e84" style="margin-top:0!important">
                                    <div class="cc-shopItemRow_63d3c5 cc-shopItemHeaderRow_d1c91a"><h1
                                            class="cc-title_ec3f8e">Πέτρος Ιακωβίδης &amp; Ρία Ελληνίδου</h1>
                                        <div>
                                            <div class="cc-logoWrapper_0e1a90" style="width:59px;height:59px"><img
                                                    data-src="https://cdn.e-food.gr/shop/4822595/logo?t=1647428522"
                                                    loading="lazy" alt="The Espressonist" width="59" height="59"
                                                    class="cc-image_a03f68 lazyloaded"
                                                    src="${vog}"
                                                    style="
    border: 1px solid black;
"></div>
                                        </div>
                                    </div>
                                    <div class="cc-shopItemRow_63d3c5">
                                        <div>
                                            <div class="cc-deliveryType_9c532e">Κράτηση για: Δευτερα 25 Μαρτιου 2025
                                                <svg aria-hidden="true" focusable="false" role="img"
                                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
                                                     class="cc-angleDown_ecfd80" width="100%" height="100%">
                                                    <path fill="currentColor"
                                                          d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                        <img src="${topView}"
                             style="
                             transform: translate(-50%, -50%);
    left: 50%;
    position: absolute;
    top: 50%;
   max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  display: block;
  margin: auto;
"></div>
                </div>
            </div>
        </div>
    </main>
</div>





`;

EventContainer.reg('event-container');
